export enum EvaluationTypes {
  Quality,
  Progress,
}
